import { render } from "./VoteStatsShort.vue?vue&type=template&id=e07cc432"
import script from "./VoteStatsShort.vue?vue&type=script&lang=js"
export * from "./VoteStatsShort.vue?vue&type=script&lang=js"

import "./VoteStatsShort.vue?vue&type=style&index=0&id=e07cc432&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__